// removed by extract-text-webpack-plugin
module.exports = {"wrap":"SearchField-wrap","searchIcon":"SearchField-searchIcon","searchField":"SearchField-searchField","searchClear":"SearchField-searchClear"};


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/components/search/SearchField.scss
// module id = 986
// module chunks = 10